import { z } from 'zod'

import { ChannelIdZod } from '../channels/channel-zod'
import { DateZod } from '../common'

export const UserChannelPreferencesZod = z.object({
  muted: z.boolean().nullish().default(false),
  lastReadEveningId: z.number().nullish(),
  lastReadAt: DateZod.nullish(),
})

export const UserSupportReadZod = z.object({
  lastReadAt: DateZod,
})

export const UserZod = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  timestamp: DateZod,
  overrides: z
    .object({
      regionId: z.string().optional(),
    })
    .partial()
    .optional(),
  channels: z.record(ChannelIdZod, UserChannelPreferencesZod).nullish(),
  supportReads: z.record(z.string(), UserSupportReadZod).nullish().default({}),
})
